// import * as firebase from 'firebase'
import authApi from '@/api/AuthAPI'
import account from '@/api/AccountAPI'
import router from '@/router'

const state = {
  user: null
}

const mutations = {
  setUser (state, payload) {
    console.log('commit set user')
    console.log(payload)
    state.user = payload
    if (payload !== null) {
      const jwt = window.localStorage.getItem('jwt')
      window.location.href = `uniwebview://set-user?token=${jwt}&userId=${payload.id}`
    }
  }
}

const getters = {
  user (state) {
    return state.user
  },
  isAdminUser (state) {
    return state.user.role === 'admin' || state.user.role === 'dev'
  },
  isATTUser (state) {
    return state.user.role === 'admin' || state.user.role === 'dev' || state.user.role === 'atntbasic'
  },
  isManagerUser (state) {
    return state.user.role === 'manager'
  },
  isAuthenticated (state) {
    return state.user !== null && state.user !== undefined
  }
}

const actions = {
  signup ({ commit }, payload) {
    commit('setLoading', true, { root: true })
    commit('clearError', null, { root: true })
    authApi.signup(payload.firstName, payload.lastName, payload.email, payload.password, payload.organisation, payload.agreed)
      .then(resp => {
        console.log('done!')
        console.log(resp)
        commit('setLoading', false, { root: true })
        router.push('/registration/complete')
      })
      .catch(error => {
        commit('setLoading', false, { root: true })
        commit('setError', error, { root: true })
        console.log(error)
      })
  },
  signin ({ commit }, payload) {
    commit('setLoading', true, { root: true })
    commit('clearError', null, { root: true })
    authApi.login(payload.email, payload.password, '')
      .then(resp => {
        console.log('done!')
        commit('setLoading', false, { root: true })
        const newUser = {
          id: resp.data.account.id,
          firstName: resp.data.user.firstName,
          lastName: resp.data.user.lastName,
          role: resp.data.user.role,
          token: resp.data.token,
          organisation: resp.data.organisation.name,
          organisationId: resp.data.organisation.id,
          fbKeys: {}
        }
        commit('setUser', newUser)
        // if (router.params.nextUrl != null) {
        //   router.push(router.params.nextUrl)
        // } else {
        // router.push('/')
        // }
        router.push('/')
      })
      .catch(error => {
        commit('setLoading', false, { root: true })
        commit('setError', error, { root: true })
        console.log(error)
      })
  },
  loadUserData ({ commit, dispatch }, payload) {
    console.log('store/user :: loadUserData ')
    commit('setLoading', true, { root: true })
    account.loadAccount('me')
      .then(resp => {
        console.log(resp)
        commit('setLoading', false, { root: true })
        const userData = {
          id: resp.data.account.id,
          firstName: resp.data.account.firstName,
          lastName: resp.data.account.lastName,
          email: resp.data.account.email,
          role: resp.data.account.role,
          organisation: resp.data.organisation.name,
          organisationId: resp.data.organisation.id
        }
        commit('setUser', userData)
      })
      .catch(error => {
        commit('setLoading', false, { root: true })
        commit('setError', error, { root: true })
        console.log(error)
        // Log the user out of any error happens here
        dispatch('signout')
      })
  },
  autoSignIn ({ commit }, payload) {
    commit('setUser', {
      token: payload.token,
      role: payload.role
    })
    // router.push('/')
  },
  signout ({ commit }) {
    window.localStorage.removeItem('jwt')
    commit('setUser', null)
    router.push(`/welcome/${localStorage.getItem('token')}`)
  },
  resetPassword ({ commit }, payload) {
    commit('setLoading', true, { root: true })
    commit('clearError', null, { root: true })
    return new Promise((resolve, reject) => {
      authApi.resetPassword(payload.email)
        .then(resp => {
          commit('setLoading', false, { root: true })
          resolve()
        })
        .catch(error => {
          commit('setLoading', false, { root: true })
          commit('setError', error, { root: true })
          console.log(error)
          reject(error)
        })
    })
  },
  validateResetPasswordHash ({ commit }, payload) {
    commit('setLoading', true, { root: true })
    commit('clearError', null, { root: true })
    return new Promise((resolve, reject) => {
      authApi.validateResetPasswordHash(payload.hash)
        .then(resp => {
          commit('setLoading', false, { root: true })
          resolve()
        })
        .catch(error => {
          commit('setLoading', false, { root: true })
          commit('setError', error, { root: true })
          console.log(error)
          reject(error)
        })
    })
  },
  setNewPasswordHash ({ commit }, payload) {
    commit('setLoading', true, { root: true })
    commit('clearError', null, { root: true })
    return new Promise((resolve, reject) => {
      authApi.setNewPassword(payload.hash, payload.password)
        .then(resp => {
          commit('setLoading', false, { root: true })
          resolve()
        })
        .catch(error => {
          commit('setLoading', false, { root: true })
          commit('setError', error, { root: true })
          console.log(error)
          reject(error)
        })
    })
  },
  confirmEmail ({ commit }, payload) {
    commit('setLoading', true, { root: true })
    commit('clearError', null, { root: true })
    return new Promise((resolve, reject) => {
      authApi.confirmEmail(payload.hash)
        .then(resp => {
          commit('setLoading', false, { root: true })
          resolve()
        })
        .catch(error => {
          commit('setLoading', false, { root: true })
          commit('setError', error, { root: true })
          console.log(error)
          reject(error)
        })
    })
  },
  validateInvitationHash ({ commit }, payload) {
    commit('setLoading', true)
    commit('clearError', null, { root: true })
    return new Promise((resolve, reject) => {
      authApi.validateInvitationHash(payload.hash)
        .then(resp => {
          commit('setLoading', false, { root: true })
          resolve(resp)
        })
        .catch(error => {
          commit('setLoading', false, { root: true })
          commit('setError', error, { root: true })
          console.log(error)
          reject(error)
        })
    })
  },
  acceptInvitation ({ commit }, payload) {
    commit('setLoading', true, { root: true })
    commit('clearError', null, { root: true })
    return new Promise((resolve, reject) => {
      authApi.acceptInvitation(payload.hash, payload.password)
        .then(resp => {
          commit('setLoading', false, { root: true })
          resolve(resp)
        })
        .catch(error => {
          commit('setLoading', false, { root: true })
          commit('setError', error, { root: true })
          console.log(error)
          reject(error)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
